// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.incyia-date {
  width: 100%;
  position: relative;
}

.incyia-date-label {
  display: block;
  margin-bottom: 6px;
  font-family: Lato, sans-serif;
  font-size: 12.5px;
  font-weight: 600;
  color: #0b1e2d;
}

.incyia-date .rs-picker {
  width: 100% !important;
}

.incyia-date .rs-picker-toggle,
.incyia-date .rs-picker-toggle.rs-btn,
.incyia-date .rs-picker-input-group,
.incyia-date .rs-input-group {
  min-height: 40px !important;
  height: 40px !important;
  border-radius: 8px !important;
  border: 1px solid #dfe7e8 !important;
  background: #fff !important;
  box-shadow: none !important;
  font-family: Lato, sans-serif !important;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.incyia-date .rs-picker-toggle:hover,
.incyia-date .rs-input-group:hover {
  border-color: #8a9ba7 !important;
}

.incyia-date .rs-picker-focused .rs-picker-toggle,
.incyia-date .rs-picker-toggle.rs-btn-active,
.incyia-date .rs-picker-toggle:focus,
.incyia-date .rs-input-group:focus-within {
  border-color: #0d9b87 !important;
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.14) !important;
}

.incyia-date .rs-picker-toggle-textbox,
.incyia-date .rs-picker-toggle-value,
.incyia-date .rs-picker-toggle .rs-picker-toggle-textbox,
.incyia-date .rs-input {
  font-family: Lato, sans-serif !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #0b1e2d !important;
  line-height: 1.4 !important;
}

.incyia-date .rs-picker-toggle-placeholder {
  font-size: 14px !important;
  color: #8a9ba7 !important;
  font-weight: 500 !important;
}

.incyia-date .rs-picker-toggle-clean,
.incyia-date .rs-picker-toggle-caret {
  color: #5f7484 !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}

.incyia-date .rs-picker-toggle-clean:hover {
  color: #0b1e2d !important;
}

/* Calendar popup */
.rs-picker-daterange-menu,
.rs-picker-menu {
  border-radius: 12px !important;
  border: 1px solid #dfe7e8 !important;
  box-shadow: 0 16px 40px rgba(6, 21, 36, 0.14) !important;
  font-family: Lato, sans-serif !important;
  overflow: hidden;
}

.rs-calendar-table-cell-selected .rs-calendar-table-cell-content,
.rs-calendar-table-cell-in-range:before {
  background-color: #0d9b87 !important;
}

.rs-calendar-table-cell-in-range .rs-calendar-table-cell-content {
  background-color: #e1f4f0 !important;
  color: #076b5c !important;
}

.rs-calendar-table-cell-selected .rs-calendar-table-cell-content {
  color: #fff !important;
}

.rs-calendar-table-cell-content:hover {
  background-color: #f7fafa !important;
}

.rs-picker-toolbar-right .rs-btn-primary {
  background: #0d9b87 !important;
  border-color: #0d9b87 !important;
  border-radius: 8px !important;
  font-family: Lato, sans-serif !important;
}

.rs-picker-toolbar-right .rs-btn-primary:hover {
  background: #076b5c !important;
  border-color: #076b5c !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/DateSelector.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;EAIE,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;EAC3B,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;;EAIE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;;;;EAIE,wCAAwC;EACxC,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;;EAEE,8BAA8B;EAC9B,oCAAoC;EACpC,wDAAwD;EACxD,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC","sourcesContent":[".incyia-date {\n  width: 100%;\n  position: relative;\n}\n\n.incyia-date-label {\n  display: block;\n  margin-bottom: 6px;\n  font-family: Lato, sans-serif;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #0b1e2d;\n}\n\n.incyia-date .rs-picker {\n  width: 100% !important;\n}\n\n.incyia-date .rs-picker-toggle,\n.incyia-date .rs-picker-toggle.rs-btn,\n.incyia-date .rs-picker-input-group,\n.incyia-date .rs-input-group {\n  min-height: 40px !important;\n  height: 40px !important;\n  border-radius: 8px !important;\n  border: 1px solid #dfe7e8 !important;\n  background: #fff !important;\n  box-shadow: none !important;\n  font-family: Lato, sans-serif !important;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.incyia-date .rs-picker-toggle:hover,\n.incyia-date .rs-input-group:hover {\n  border-color: #8a9ba7 !important;\n}\n\n.incyia-date .rs-picker-focused .rs-picker-toggle,\n.incyia-date .rs-picker-toggle.rs-btn-active,\n.incyia-date .rs-picker-toggle:focus,\n.incyia-date .rs-input-group:focus-within {\n  border-color: #0d9b87 !important;\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.14) !important;\n}\n\n.incyia-date .rs-picker-toggle-textbox,\n.incyia-date .rs-picker-toggle-value,\n.incyia-date .rs-picker-toggle .rs-picker-toggle-textbox,\n.incyia-date .rs-input {\n  font-family: Lato, sans-serif !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  color: #0b1e2d !important;\n  line-height: 1.4 !important;\n}\n\n.incyia-date .rs-picker-toggle-placeholder {\n  font-size: 14px !important;\n  color: #8a9ba7 !important;\n  font-weight: 500 !important;\n}\n\n.incyia-date .rs-picker-toggle-clean,\n.incyia-date .rs-picker-toggle-caret {\n  color: #5f7484 !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n}\n\n.incyia-date .rs-picker-toggle-clean:hover {\n  color: #0b1e2d !important;\n}\n\n/* Calendar popup */\n.rs-picker-daterange-menu,\n.rs-picker-menu {\n  border-radius: 12px !important;\n  border: 1px solid #dfe7e8 !important;\n  box-shadow: 0 16px 40px rgba(6, 21, 36, 0.14) !important;\n  font-family: Lato, sans-serif !important;\n  overflow: hidden;\n}\n\n.rs-calendar-table-cell-selected .rs-calendar-table-cell-content,\n.rs-calendar-table-cell-in-range:before {\n  background-color: #0d9b87 !important;\n}\n\n.rs-calendar-table-cell-in-range .rs-calendar-table-cell-content {\n  background-color: #e1f4f0 !important;\n  color: #076b5c !important;\n}\n\n.rs-calendar-table-cell-selected .rs-calendar-table-cell-content {\n  color: #fff !important;\n}\n\n.rs-calendar-table-cell-content:hover {\n  background-color: #f7fafa !important;\n}\n\n.rs-picker-toolbar-right .rs-btn-primary {\n  background: #0d9b87 !important;\n  border-color: #0d9b87 !important;\n  border-radius: 8px !important;\n  font-family: Lato, sans-serif !important;\n}\n\n.rs-picker-toolbar-right .rs-btn-primary:hover {\n  background: #076b5c !important;\n  border-color: #076b5c !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
